const VideoStatus = {
  Disabled: 'disabled',
  Loading: 'loading',
  Enabled: 'enabled',
};

export default VideoStatus;
